import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { DsHintModule } from '@bmw-ds/components';

import { BackButtonComponent } from '../back-button/back-button.component';

@Component({
  selector: 'cdf-top-section',
  imports: [BackButtonComponent, DsHintModule],
  template: `
    <div class="toolbar">
      <cdf-back-button [disabled]="disabled()" />
      <ng-content select="[topSectionTopRight]" />
    </div>
    <ng-content />
  `,
  styleUrl: './top-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TopSectionComponent {
  readonly disabled = input<boolean>(false);
}
